import client from './client';
import players from './players';
import channel from './channel';
import tvshows from './tvshows';
import video from './video';
import personal from './personal';
import schedule from './schedule';
import favteam from './favteam';
import event from './event';
import pagenav from './pagenav';
import videolist from './videolist';
import favorite from './favorite';
import history from './history';
import recommended from './recommended';

export default {
	client,
	players,
	channel,
	tvshows,
	video,
	personal,
	schedule,
	favteam,
	favorite,
	history,
	recommended,
	event,
	pagenav,
	videolist,
	isServerSide: (state = false) => state,
};
